import { render, staticRenderFns } from "./replayemail-popup.vue?vue&type=template&id=265c0f0d&"
import script from "./replayemail-popup.vue?vue&type=script&lang=js&"
export * from "./replayemail-popup.vue?vue&type=script&lang=js&"
import style0 from "./replayemail-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports